namespace GeniuzPOS.ReportMasterData {
    export interface Report_1505Row {
        Id?: string;
        DocDate?: string;
        DocDateEn?: string;
        Year?: string;
        BrandCode?: string;
        BrandName?: string;
        Qty?: number;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
    }

    export namespace Report_1505Row {
        export const idProperty = 'Id';
        export const nameProperty = 'DocDate';
        export const localTextPrefix = 'ReportMasterData.Report_1505';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายเดือน:ยอดขายรวมร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายเดือน:ยอดขายรวมร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายเดือน:ยอดขายรวมร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายเดือน:ยอดขายรวมร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            DocDate = "DocDate",
            DocDateEn = "DocDateEn",
            Year = "Year",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            Qty = "Qty",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales"
        }
    }
}
